
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-solution",
      function () {
        return require("private-next-pages/our-solution.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-solution"])
      });
    }
  